import { PriceDetails } from '../atoms/productPriceHistory.atom'

export const FormattedPriceSummary = (props: PriceDetails['summary']) => {
  if (!props.discountedPrice) {
    return (
      <>
        {props.price} / {props.frequency}
      </>
    )
  }

  return (
    <>
      {props.discountedPrice}
      <span style={{ textDecoration: 'line-through', marginLeft: '4px' }}>
        {props.price}
      </span>{' '}
      / {props.frequency}
    </>
  )
}
